import type { ProductCardPriceSize } from 'components/cart/NewCartItem/ProductCardPrice.types';

export const baseClasses = 'body-m-medium';

export const containerClasses = 'flex gap-x-2 items-baseline';

export const sizeClasses: Record<ProductCardPriceSize, string> = {
  base: 'body-m',
  small: 'body-s'
};
